"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedlocationpin01sm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 20",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedlocationpin01sm` : '') + (description ? ` desc-brandedlocationpin01sm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedlocationpin01sm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedlocationpin01sm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14 7.5C14 4.73 13.23 0 7 0 .9 0 0 4.5 0 7.5c0 4 4.63 9.5 7 12.5 2.53-2.85 7-8.5 7-12.5Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    fill: "#DAFCFE"
  }));
};
var _default = exports.default = brandedlocationpin01sm;